// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import classNames from 'clsx';
import { withClassName } from '../../hooks/withClassName.js';
import { BoxContext } from '../box/Box.js';
const StyledContent = withClassName(PopoverPrimitive.Content, 'layer-components:rounded-xl layer-components:min-w-120px layer-components:bg-white layer-components:z-menu layer-components:shadow-lg layer-components:border-default layer-components:op-0 layer-components:hidden layer-components:max-w-90vw', 'will-change-transform', 'layer-components:transform-origin-[var(--radix-popover-transform-origin)]', 'layer-components:[&[data-state=open]]:animate-popover-in', 'layer-components:[&[data-state=closed]]:animate-popover-out', 'important:motion-reduce:animate-none', 'layer-components:max-h-[var(--radix-popover-content-available-height)]', 'layer-components:[&[data-state=open]]:opacity-100 layer-components:[&[data-state=open]]:flex layer-components:[&[data-state=open]]:flex-col', 'layer-components:[&[data-state=closed]]:pointer-events-none');
const StyledArrow = withClassName(PopoverPrimitive.Arrow, 'layer-components:fill-white layer-components:stroke-black');
const StyledClose = withClassName(PopoverPrimitive.Close, 'layer-components:[all:unset] layer-components:[font-family:inherit] layer-components:rounded-lg layer-components:h-25px layer-components:w-25px layer-components:inline-flex layer-components:items-center layer-components:justify-center layer-components:color-dark-blend layer-components:absolute layer-components:top-5px layer-components:right-5px layer-components:hover:bg-lightBlend layer-components:focus:shadow-focus');
// Exports
export const PopoverRoot = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverArrow = StyledArrow;
export const PopoverClose = StyledClose;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverContent = function PopoverContent(_a) {
    var { ref, children, forceMount, disableBlur, className, radius = 'default', padding = 'default' } = _a, props = __rest(_a, ["ref", "children", "forceMount", "disableBlur", "className", "radius", "padding"]);
    return (_jsx(PopoverPrimitive.Portal, { forceMount: forceMount, children: _jsx(BoxContext.Provider, { value: { spacingScale: 1 }, children: _jsx(StyledContent, Object.assign({}, props, { forceMount: forceMount, ref: ref, className: classNames({
                    'layer-variants:important:p-0': padding === 'none',
                    'layer-variants:p-5': padding === 'default',
                    'layer-variants:rounded-none': radius === 'none',
                    'layer-variants:rounded-lg': radius === 'default',
                    'layer-variants:rounded-md': radius === 'md',
                }, className), children: children })) }) }));
};
export const Popover = Object.assign(PopoverRoot, {
    Content: PopoverContent,
    Arrow: PopoverArrow,
    Close: PopoverClose,
    Trigger: PopoverTrigger,
    Anchor: PopoverAnchor,
});
//# sourceMappingURL=Popover.js.map